(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["milanus-product-discovery"]) return;
  try {
    
  document.querySelectorAll('[data-product-discovery]').forEach(function (section) {
    var cards = Array.prototype.slice.call(section.querySelectorAll('[data-discovery-page]'));
    var previous = section.querySelector('[data-discovery-previous]');
    var next = section.querySelector('[data-discovery-next]');
    var status = section.querySelector('[data-discovery-status]');
    var shopAll = section.querySelector('[data-discovery-shop-all]');
    var pageCount = Number(section.getAttribute('data-discovery-page-count')) || 1;
    var currentPage = 0;
    var nextPageLabel = next.getAttribute('aria-label');

    function showPage(page, direction) {
      currentPage = Math.max(0, Math.min(page, pageCount - 1));
      cards.forEach(function (card) {
        card.hidden = Number(card.getAttribute('data-discovery-page')) !== currentPage;
      });
      previous.disabled = currentPage === 0;
      next.disabled = false;
      next.setAttribute('aria-label', currentPage === pageCount - 1 && shopAll ? shopAll.textContent.trim() : nextPageLabel);
      status.textContent = String(currentPage + 1) + ' / ' + String(pageCount);
      if (direction && typeof window.milanusTrack === 'function') {
        window.milanusTrack('milanus_product_discovery_paginated', {
          direction: direction,
          discovery_page: currentPage + 1,
          products_visible: cards.filter(function (card) { return !card.hidden; }).length
        });
      }
    }

    previous.addEventListener('click', function () { showPage(currentPage - 1, 'previous'); });
    next.addEventListener('click', function () {
      if (currentPage === pageCount - 1 && shopAll) {
        if (typeof window.milanusTrack === 'function') {
          window.milanusTrack('milanus_product_discovery_paginated', { direction: 'shop_all', discovery_page: currentPage + 1, products_visible: 4 });
        }
        window.location.assign(shopAll.href);
        return;
      }
      showPage(currentPage + 1, 'next');
    });
    showPage(0);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["milanus-product-recommendations"]) return;
  try {
    
  document.querySelectorAll('[data-milanus-recommendations]').forEach(function (section) {
    if (section.dataset.kitCarouselReady === 'true') return;
    section.dataset.kitCarouselReady = 'true';
    var cards = Array.prototype.slice.call(section.querySelectorAll('[data-kit-page]'));
    var previous = section.querySelector('[data-kit-previous]');
    var next = section.querySelector('[data-kit-next]');
    var status = section.querySelector('[data-kit-status]');
    var shopAll = section.querySelector('[data-kit-shop-all]');
    var pageCount = Number(section.getAttribute('data-kit-page-count')) || 1;
    var currentPage = 0;
    var nextPageLabel = next.getAttribute('aria-label');

    function showPage(page, direction) {
      currentPage = Math.max(0, Math.min(page, pageCount - 1));
      cards.forEach(function (card) {
        card.hidden = Number(card.getAttribute('data-kit-page')) !== currentPage;
      });
      previous.disabled = currentPage === 0;
      next.disabled = false;
      next.setAttribute('aria-label', currentPage === pageCount - 1 && shopAll ? shopAll.textContent.trim() : nextPageLabel);
      status.textContent = String(currentPage + 1) + ' / ' + String(pageCount);
      if (direction && typeof window.milanusTrack === 'function') {
        window.milanusTrack('milanus_product_recommendations_page', {
          direction: direction,
          recommendation_page: currentPage + 1,
          products_visible: cards.filter(function (card) { return !card.hidden; }).length,
          recommendation_source: 'kits_best_selling'
        });
      }
    }

    previous.addEventListener('click', function () { showPage(currentPage - 1, 'previous'); });
    next.addEventListener('click', function () {
      if (currentPage === pageCount - 1 && shopAll) {
        if (typeof window.milanusTrack === 'function') {
          window.milanusTrack('milanus_product_recommendations_page', { direction: 'shop_all', recommendation_page: currentPage + 1, products_visible: 4, recommendation_source: 'kits_best_selling' });
        }
        window.location.assign(shopAll.href);
        return;
      }
      showPage(currentPage + 1, 'next');
    });
    showPage(0);
    window.setTimeout(function () {
      section.dispatchEvent(new CustomEvent('milanus:recommendations:loaded', { bubbles: true }));
    }, 0);
  });

  } catch(e) { console.error(e); }
})();
})();
